import { schema } from 'normalizr';

import { processViewerIsFollowingUser } from '../strategies/viewerIsFollowingUser';

export const viewerIsFollowingUserSchema: schema.Entity = new schema.Entity(
  'viewerIsFollowingUsers',
  {},
  { processStrategy: processViewerIsFollowingUser }
);

export type ViewerIsFollowingUserEdgesSchema = typeof viewerIsFollowingUserEdgesSchema;
export const viewerIsFollowingUserEdgesSchema: schema.Object[] = [
  new schema.Object({ node: viewerIsFollowingUserSchema }),
];
